import AppHeader from '~/components/Layout/AppHeader.vue'
import AppFooter from '~/components/Layout/AppFooter.vue'

const __default__ = {
    name: 'default',
}

export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {


return { __sfc: true,AppHeader, AppFooter }
}

})